export default __webpack_public_path__ + "static/media/laboratory.ac984abe.png";